export const numToFixed = (value = 0, fractionDigits = 0) => +value.toFixed(fractionDigits);
